<template>
  <div class="wrapper store-coop-list">
    <admin-title :title="$route.meta.name" />
    <div class="header-search">
      <el-form ref="searchForm" inline :model="searchData" label-width="">
        <el-form-item label="门店名称">
          <el-input
            v-model.trim="searchData.storeName"
            size="small"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="区域负责人">
          <SelectAdminUser
            ref="areaFollowUserSelect"
            v-model="searchData.areaFollowUserId"
            :job-code="AdminJobCode.A001"
            width="200px"
            @input="handleAreaFollowUserSelect"
          />
        </el-form-item>
        <el-form-item label="合作状态">
          <el-select
            v-model="searchData.cooperationStatus"
            size="small"
            placeholder="请选择"
            clearable
            style="width: 160px"
          >
            <el-option
              v-for="item in cooperationStatusOptions"
              :key="`${item.label}-${item.value}`"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">
            查询
          </el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider />
    <div class="toolbar-right">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.store_cooperation_partner_export)"
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportExcel"
      >
        导出
      </el-button>
    </div>

    <tp-table
      :isNeedSerialNumber="true"
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
    />

    <EditServiceFeeDialog
      :visible.sync="serviceFeeDialog.visible"
      :row-id="serviceFeeDialog.rowId"
      :current-rate="serviceFeeDialog.currentRate"
      @success="getList"
    />

    <JointCooperationConfigDialog
      :visible.sync="jointConfigDialog.visible"
      :id="jointConfigDialog.id"
      :current-tpl-id="jointConfigDialog.currentTplId"
      @saved="getList"
    />
  </div>
</template>

<script>
import axios from "axios";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import SelectAdminUser from "@/views/components/select-admin-user.vue";
import { AdminJobCode } from "@/enum/dict/index.js";
import EditServiceFeeDialog from "./components/edit-service-fee-dialog.vue";
import JointCooperationConfigDialog from "./components/joint-cooperation-config-dialog.vue";
import {
  getJointPartnerStorePageAPI,
  exportJointPartnerStoreAPI,
  downloadJointAgreementAPI,
  editJointOrderStatusAPI,
  editJointAccessStatusAPI,
} from "./api";

const COOPERATION_PENDING_SIGN = 1;
const COOPERATION_COOPERATING = 2;
const COOPERATION_TERMINATED = 3;
const COOPERATION_CLOSED = 4;

const cooperationStatusOptions = [
  { label: "全部", value: "" },
  { label: "待签署", value: COOPERATION_PENDING_SIGN },
  { label: "合作中", value: COOPERATION_COOPERATING },
  { label: "已终止", value: COOPERATION_TERMINATED },
  { label: "已关闭", value: COOPERATION_CLOSED },
];

function coopJLine(h, label, val) {
  const text = val != null && val !== "" ? val : "-";
  return (
    <div class="j-line">
      <span class="lbl">{label}：</span>
      <span class="val">{text}</span>
    </div>
  );
}

const columns = [
  {
    label: "门店信息",
    prop: "storeInfo",
    minWidth: "240",
    customRender(h, row) {
      const status = row.cooperationStatus;
      const isCoop = status === COOPERATION_COOPERATING;
      const isPending = status === COOPERATION_PENDING_SIGN;
      const isTerminated = status === COOPERATION_TERMINATED;
      const isClosed = status === COOPERATION_CLOSED;
      return (
        <div class="joint-cell">
          <div class="j-line">
            <span class="lbl">门店名称：</span>
            <span class="val">
              {row.storeName || "-"}
              {isCoop ? (
                <el-tag size="mini" type="success" style="margin-left: 8px;">
                  合作中
                </el-tag>
              ) : null}
              {isPending ? (
                <el-tag size="mini" type="info" style="margin-left: 8px;">
                  待签署
                </el-tag>
              ) : null}
              {isTerminated ? (
                <el-tag size="mini" type="danger" style="margin-left: 8px;">
                  已终止
                </el-tag>
              ) : null}
              {isClosed ? (
                <el-tag size="mini" type="warning" style="margin-left: 8px;">
                  已关闭
                </el-tag>
              ) : null}
            </span>
          </div>
          {coopJLine(h, "门店地址", row.address)}
        </div>
      );
    },
  },
  {
    label: "区域负责人",
    prop: "areaFollowUserName",
    minWidth: "110",
    customRender(h, row) {
      return <p class="joint-plain">{row.areaFollowUserName || "-"}</p>;
    },
  },
  {
    label: "合作时间",
    prop: "cooperateTime",
    minWidth: "170",
    customRender(h, row) {
      return <p class="joint-plain">{row.cooperateTime || "-"}</p>;
    },
  },
  {
    label: "联营模版",
    prop: "jointTplName",
    minWidth: "140",
    customRender(h, row) {
      return <p class="joint-plain">{row.jointTplName || "-"}</p>;
    },
  },
  {
    label: "进件状态",
    prop: "enableJointOrder",
    minWidth: "110",
    customRender(h, row) {
      const canEdit = this.isShowBtn(
        this.AUTH_BTN.store_cooperation_partner_entry_status,
      );
      return (
        <div class="joint-switch">
          <el-switch
            disabled={!canEdit}
            onChange={() => this.changeJointOrderStatus(row)}
            v-model={row["enableJointOrder"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          />
        </div>
      );
    },
  },
  {
    label: "服务费率",
    prop: "serviceRate",
    minWidth: "110",
    customRender(h, row) {
      const canEditRate = this.isShowBtn(
        this.AUTH_BTN.store_cooperation_partner_service_rate_edit,
      );
      return (
        <span class="rate-with-edit">
          <span class="joint-plain">
            {row.serviceRate != null && row.serviceRate !== "" ? `${row.serviceRate}%` : "-"}
          </span>
          {canEditRate ? (
            <i
              class="el-icon-edit-outline edit-rate-icon"
              title="修改服务费率"
              onClick={() => this.openEditServiceFee(row)}
            />
          ) : null}
        </span>
      );
    },
  },
  {
    label: "结算账户余额",
    prop: "settleAccountBalance",
    minWidth: "130",
    customRender(h, row) {
      const v = row.settleAccountBalance;
      return <p class="joint-plain">{v != null && v !== "" ? v : "-"}</p>;
    },
  },
  {
    label: "操作",
    width: "240",
    fixed: "right",
    customRender(h, row) {
      const inCoop = row.cooperationStatus === COOPERATION_COOPERATING;
      const canJointConfig = this.isShowBtn(
        this.AUTH_BTN.store_cooperation_partner_joint_config,
      );
      const canAgreement = this.isShowBtn(
        this.AUTH_BTN.store_cooperation_partner_agreement,
      );
      const canDisableEnable = this.isShowBtn(
        this.AUTH_BTN.store_cooperation_partner_disable_enable,
      );
      return (
        <div class="op-links">
          {canJointConfig ? (
            <el-link
              underline={false}
              type="primary"
              onClick={() => this.openJointConfigDialog(row)}
            >
              联营配置
            </el-link>
          ) : null}
          {canDisableEnable ? (
            <el-link
              underline={false}
              type="primary"
              onClick={() => this.toggleJointAccess(row)}
            >
              {row.enableAccessJoint ? "禁用" : "启用"}
            </el-link>
          ) : null}
          {inCoop && canAgreement ? (
            <el-tooltip
              effect="dark"
              content="点击下载合作协议，只有在合作状态为合作中的时候展示"
              placement="top"
            >
            <span class="agreement-link-wrap">
            <el-link
              underline={false}
              type="primary"
              onClick={() => this.downloadAgreement(row)}
            >
              合作协议
            </el-link>
            </span>
            </el-tooltip>
          ) : null}
        </div>
      );
    },
  },
];

export default {
  name: "JointPartnerStoreList",
  mixins: [authBtnMixin],
  components: {
    SelectAdminUser,
    EditServiceFeeDialog,
    JointCooperationConfigDialog,
  },
  data() {
    return {
      AdminJobCode,
      columns,
      cooperationStatusOptions,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        storeName: "",
        areaFollowUserId: "",
        areaFollowUserName: "",
        cooperationStatus: "",
      },
      serviceFeeDialog: {
        visible: false,
        rowId: null,
        currentRate: 0,
      },
      jointConfigDialog: {
        visible: false,
        id: null,
        currentTplId: null,
      },
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleAreaFollowUserSelect(userId) {
      if (!userId) {
        this.searchData.areaFollowUserName = "";
        this.searchData.areaFollowUserId = "";
        return;
      }
      const list = this.$refs.areaFollowUserSelect?.list || [];
      const u = list.find((item) => item.id === userId);
      this.searchData.areaFollowUserId = userId;
      this.searchData.areaFollowUserName = u ? u.userName : "";
    },
    handleQuery() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.searchData = {
        storeName: "",
        areaFollowUserId: "",
        areaFollowUserName: "",
        cooperationStatus: "",
      };
      this.currentPage = 1;
      this.getList();
    },
    async getList() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        storeName: this.searchData.storeName || undefined,
        areaFollowUserName: this.searchData.areaFollowUserName || undefined,
      };
      if (
        this.searchData.cooperationStatus !== "" &&
        this.searchData.cooperationStatus != null
      ) {
        params.cooperationStatus = this.searchData.cooperationStatus;
      }
      try {
        const res = await getJointPartnerStorePageAPI(params);
        this.list = res.list || [];
        this.total = res.total || 0;
      } catch (e) {
        this.list = [];
        this.total = 0;
      }
    },
    exportExcel() {
      const data = {
        storeName: this.searchData.storeName || undefined,
        areaFollowUserName: this.searchData.areaFollowUserName || undefined,
      };
      if (
        this.searchData.cooperationStatus !== "" &&
        this.searchData.cooperationStatus != null
      ) {
        data.cooperationStatus = this.searchData.cooperationStatus;
      }
      exportJointPartnerStoreAPI(data);
    },
    openEditServiceFee(row) {
      this.serviceFeeDialog.rowId = row.id;
      this.serviceFeeDialog.currentRate = row.serviceRate;
      this.serviceFeeDialog.visible = true;
    },
    openJointConfigDialog(row) {
      this.jointConfigDialog.id = row.id;
      this.jointConfigDialog.currentTplId = row.jointTplId;
      this.jointConfigDialog.visible = true;
    },
    changeJointOrderStatus(row) {
      const { id, enableJointOrder } = row;
      editJointOrderStatusAPI({ id, enableJointOrder })
        .then(() => {
          this.$message.success("操作成功");
          this.getList();
        })
        .catch(() => {
          row.enableJointOrder = !enableJointOrder;
        });
    },
    toggleJointAccess(row) {
      const { id, enableAccessJoint } = row;
      const next = !enableAccessJoint;
      const statusDesc = next ? "启用" : "禁用";
      this.$confirm(`该操作将${statusDesc}门店联营功能，是否继续。`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await editJointAccessStatusAPI({ id, enableAccessJoint: next });
            this.$message.success("操作成功");
            this.getList();
          } catch {
            // 错误提示由 http 统一处理
          }
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    /**
     * 下载合作协议 — 调用后端接口获取协议链接，以 blob 方式下载到本地
     */
    async downloadAgreement(row) {
      try {
        // 1. 获取协议文件URL
        const res = await downloadJointAgreementAPI(row.id);
        const url = res?.agreementUrl;
        if (!url) {
          this.$message.warning("暂无合作协议下载地址");
          return;
        }
        // 2. 以 blob 形式拉取文件并触发浏览器下载
        const blobRes = await axios({
          method: "get",
          url,
          responseType: "blob",
        });
        const blob = blobRes.data;
        const blobUrl = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = blobUrl;
        a.download = `${row.storeName || "门店"}合作协议.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
      } catch {
        this.$message.error("获取合作协议失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbar-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
}
</style>

<style lang="scss">
@import "../coop-list-table-cells.scss";

.rate-with-edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.edit-rate-icon {
  cursor: pointer;
  color: #409eff;
  font-size: 16px;
}
.op-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.agreement-link-wrap {
  display: inline-block;
}
</style>
